import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { TranslatorContext } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from 'gw-digital-auth-react';
import metadata from './PageBannerComponent.metadata.json5';
import styles from './PageBannerComponent.module.scss';
import messages from './PageBannerComponent.messages';
import {getPageHeaderImage} from "../../customer/module/nexus-portals-util-js/lobIconUtil";

function PageBannerComponent(props) {
    const { pageName, pageTitle } = props;
    const translator = useContext(TranslatorContext);
    const { env } = appConfig;  
    const breakpoint = useContext(BreakpointTrackerContext); 
    

    const getLogoSrc = useCallback(() => {
        const url = _.get(env, 'DEPLOYMENT_URL');
        const breakpoint = useContext(BreakpointTrackerContext);
        const logoUrl = breakpoint === 'desktop' ? `${url}/branding/eylogo.png` : `${url}/branding/eylogo.png`
       // const logoUrl = (breakpoint === 'phone') ? `${url}/branding/Trillium_Primary_Logo_RGB.png` : `${url}/branding/Trillium_Secondary_Logo_Horizontal_RGB.png`       
       return logoUrl;
    }, [env]);

    const getBanner = useCallback((polCommonDetails) => {
        const url = _.get(env, 'DEPLOYMENT_URL');
        const lobBannerImage = getPageHeaderImage(pageName);
        //const lobBannerImage = 'banner-vehicle.jpg'
        const logoUrl = `${url}/branding/${lobBannerImage}`       
       return logoUrl;
    }, [env]);

    const overrides = {
        bgPolicyTypeImage: {
            src: getBanner(pageName)
        },
        pageTitle: {
            content: pageTitle ? pageTitle : `Welcome ${_.capitalize(useAuthentication().given_name)}!`
        },
    };

    

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            //applicationheader: ApplicationHeader
        },
        resolveCallbackMap:{
           // onFileAClaimButtonClick: onFileAClaimButtonClick,
           // goToLogout: auth.logout
        }
    };

    

    return renderContentFromMetadata(metadata.componentContent, overrides, resolvers);
}

PageBannerComponent.propTypes = {
    //routes: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default withRouter(PageBannerComponent);
